import { observer } from 'mobx-react-lite';
import { Route, Routes } from 'react-router-dom';
import { FlexFill, Footer, Tab, Tabs } from '../../../../components';
import Product from '../../store/Product';
import ExtendedFeaturesRoute from '../extended';
import FilesRoute from '../files';
import GeneralRoute from '../general';
import PulseKeysRoute from '../pulse-keys';
import DuplicateButton from './DuplicateButton';
import MakeShareableLinksButton from './MakeShareableLinksButton';
import ProductValidation from './ProductValidation';
import ArchiveSellableButton from './sellable/ArchiveSellableButton';
import SaveSellableButton from './sellable/SaveSellableButton';

export default observer(function ProductForm({
  product,
}: {
  product: Product;
}) {
  return (
    <>
      {product.isNew && (
        <Tabs>
          <Tab label="General" value="" />
          <Tab label="Files" value="files" />
        </Tabs>
      )}
      {!product.isNew && (
        <Tabs>
          <Tab label="General" value="" />
          <Tab label="Files" value="files" />
          <Tab label="Pulse Keys" value="pulse-keys" />
          <Tab label="Extended Features" value="extended-features" />
        </Tabs>
      )}

      <Routes>
        <Route element={<GeneralRoute product={product} />} index />
        <Route element={<FilesRoute product={product} />} path="files" />
        <Route
          element={<PulseKeysRoute product={product} />}
          path="pulse-keys"
        />
        <Route
          element={<ExtendedFeaturesRoute product={product} />}
          path="extended-features"
        />
      </Routes>

      <ProductValidation product={product} />

      <Footer sx={{ mt: 2 }}>
        <SaveSellableButton sellable={product} sellableName="Product" />
        <MakeShareableLinksButton product={product} />
        <DuplicateButton product={product} />
        <ArchiveSellableButton sellable={product} sellableName="Product" />
        <FlexFill />
      </Footer>
    </>
  );
});
